import {FC, useEffect, useState} from 'react'
import {Form} from 'react-bootstrap'
import {TableBusiness} from '../../../../generales_component/table/TableBusiness'

const headersUser = [
  {
    key: 'dni',
    value: 'Nro. Doc.',
  },
  {
    key: 'nombre',
    value: 'Nombres',
  },
]

interface MyComponentProps {
  tbody: {[key: string]: any}[]
  onCheckSelect: (Ids: string[]) => void
}

const UnitByRole: FC<MyComponentProps> = (props) => {
  const {tbody, onCheckSelect} = props

  const [checkItems, setCheckItems] = useState<string[]>([])
  const [users, setUsers] = useState(tbody)

  useEffect(() => {
    setUsers(tbody)
    setCheckItems([])
  }, [tbody])

  useEffect(() => {
    onCheckSelect(checkItems)
  }, [checkItems])

  return (
    <>
      <Form.Control
        type='text'
        placeholder='Buscar usuario ....'
        className='my-3'
        onChange={(e) => {
          const value = e.target.value

          const filterUsers = tbody.filter(
            (u) =>
              u.dni?.toString().toLowerCase().includes(value) ||
              u.nombre?.toLowerCase().includes(value)
          )
          setUsers(filterUsers)
        }}
      />

      <TableBusiness
        checkbox={{
          include: true,
          onChange: (e) => {
            const items = e.target.checked ? users.map((x) => x._id) : []
            setCheckItems(items)
          },
        }}
        headers={headersUser}
      >
        {users.map((user) => (
          <tr key={user._id}>
            <td>
              <Form.Check
                type='checkbox'
                checked={checkItems.includes(user._id)}
                onChange={(e) => {
                  const isChecked = e.target.checked

                  const itemsFilter = checkItems.filter((item) => item !== user._id)
                  const itemsAdd = new Set(checkItems)

                  itemsAdd.add(user._id)

                  const itemsResult = isChecked ? Array.from(itemsAdd) : itemsFilter
                  setCheckItems(itemsResult)
                }}
              />
            </td>
            <td>{user.dni}</td>
            <td>{user.nombre}</td>
          </tr>
        ))}
      </TableBusiness>
    </>
  )
}

export {UnitByRole}
